export const environment = {
  production: false,
  apiBaseUrl: 'https://tutelapatentestg-function.azurewebsites.net',
  functionKey: 'Ito3iUipzh7fgAbbSGd75yme50IhnjB2AN80SgjESIQnAzFua0BBrw=='
};
